import React, { useState, useEffect } from "react";
var globalimg ="";;
var globalPrice = "";
var globalDisplayPrice = "";
var globalTitle = "";
var globalName = "";
var globalDescription = "";
var globalPoints = [];

function ProductInfo({ change }) {
  const [basket, setBasket] = useState(window.localStorage.getItem('MuckS_Basket'));

  const [price, setPrice] = useState(globalPrice);
  const [displayPrice, setDisplayPrice] = useState(globalDisplayPrice);
  const [img, setImg] = useState(globalimg);
  const [title, setTitle] = useState(globalTitle);
  const [name, setName] = useState(globalName);
  const [description, setDescription] = useState(globalDescription);
  const [points, setPoints] = useState(globalPoints);

  const urlSearchString = window.location.search;

 const params = new URLSearchParams(urlSearchString);

 var iProductID = parseInt(params.get('product'));

  function addToBasket()
    {
      var tempBasket = [];

        if(basket == null)
        {

        }
        else
        {
          tempBasket = JSON.parse(basket);
        }
        var id = 0;  
        if(tempBasket == null)
        {

          tempBasket = [];
        }
        else
        {
          id = tempBasket.length;
        }

        tempBasket.push(
          {
            id: id,
            iProductID: iProductID,
            price: price,
            Name: name,
            img: img
          }
        );
        localStorage.setItem('MuckS_Basket', JSON.stringify(tempBasket));
        //setBasket(JSON.stringify(tempBasket));
        change(tempBasket);
        //navigate('../');

    }

    const getData = async () => {
      try 
      {
        const response = await fetch('https://mucksucker.com:3001/api/getProduct', {
          method: 'post',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            id: iProductID
          })
          })  
          const data = await response.text();
          setPrice(JSON.parse(data).price);
          var iPrice = JSON.parse(data).price;
          iPrice = (iPrice/100).toFixed(2);

          globalimg = JSON.parse(data).img;
          globalPrice = JSON.parse(data).price;
          globalDisplayPrice = iPrice;
          globalTitle = JSON.parse(data).title
          globalName = JSON.parse(data).Name;
          globalDescription = JSON.parse(data).description;
 

          setDisplayPrice(iPrice);
          setImg(JSON.parse(data).img);
          setName(JSON.parse(data).Name);
          setTitle(JSON.parse(data).title);
          setDescription(JSON.parse(data).description);

          var loopPoints = JSON.parse(data).points;
          const pointsTemp = loopPoints.map((point) =>
            <li className="liPadding">
              <p>{point}</p>
            </li>
          )
          globalPoints = pointsTemp;
          setPoints(pointsTemp);
           
        } 
        catch(err) 
        {
    
        }
    }

    useEffect(()  => {

      getData();

    }, []);

    return (
    <div className="container">
      <h1>{title}</h1>
      
      <div className="contentsGroup">
        <img alt="mainProduct" className="imgclass" src={img} />
        <div className="contentsGroup2">
          <p className="textGroup1">
            {description}
          </p>
          <ul>
            {points}
          </ul>
          <h3 className="textGroup1">Total: TBD</h3>
          {/* <h3 className="textGroup1">Total: £{displayPrice}</h3> */}
        </div>
      </div>
       <div className="addToBasketButton" onClick={addToBasket}><p>Add To Basket</p></div> 
        {/* <BasketHeader state={token}/>  login is hiddnen or not rendered from index find Basket header and un comment*/}
    </div>    
    );
  };
  
  export default ProductInfo;